module.exports = __webpack_public_path__ + "img/logo_branca.ba8f0664.png";